/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { AgentRuntimeManifest } from '../models/AgentRuntimeManifest';
import type { ChatViewResponse } from '../models/ChatViewResponse';
import type { ComparisonSummaryResponse } from '../models/ComparisonSummaryResponse';
import type { ComposedPromptResponse } from '../models/ComposedPromptResponse';
import type { CreateThreadRequest } from '../models/CreateThreadRequest';
import type { DeleteAllThreadsResponse } from '../models/DeleteAllThreadsResponse';
import type { DeleteThreadResponse } from '../models/DeleteThreadResponse';
import type { DiscoveryPlanHighlightsResponse } from '../models/DiscoveryPlanHighlightsResponse';
import type { InternalChatStreamRequest } from '../models/InternalChatStreamRequest';
import type { InternalComparisonSummaryRequest } from '../models/InternalComparisonSummaryRequest';
import type { InternalPlanHighlightsRequest } from '../models/InternalPlanHighlightsRequest';
import type { SpawnDemoSubagentRequest } from '../models/SpawnDemoSubagentRequest';
import type { SpawnDemoSubagentResponse } from '../models/SpawnDemoSubagentResponse';
import type { SubThreadChatRequest } from '../models/SubThreadChatRequest';
import type { SubThreadChatResponse } from '../models/SubThreadChatResponse';
import type { ThreadListResponse } from '../models/ThreadListResponse';
import type { ThreadResponse } from '../models/ThreadResponse';
import type { ThreadStateResponse } from '../models/ThreadStateResponse';
import type { UiEventBatchRequest } from '../models/UiEventBatchRequest';
import type { UiEventBatchResponse } from '../models/UiEventBatchResponse';

export class AgentShoppingConsultantInternalService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * (Internal/dev only) List all shopping_consultant sessions.
   * Internal-only — lists all shopping_consultant sessions, most-recent first.
   *
   * Backs the backoffice's thread picker. No production-route equivalent
   * (Invariant 17 — no end-user "list my sessions" surface designed yet).
   * @returns ThreadListResponse Successful Response
   * @throws ApiError
   */
  public listThreadsInternalAgentsShoppingConsultantChannelsGet(): CancelablePromise<ThreadListResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels',
    });
  }
  /**
   * Get or create the shopping_consultant thread for this enrollment period.
   * @param requestBody
   * @returns ThreadResponse Successful Response
   * @throws ApiError
   */
  public createOrGetThreadInternalAgentsShoppingConsultantChannelsPost(
    requestBody: CreateThreadRequest
  ): CancelablePromise<ThreadResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/channels',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/ops only) BULK delete every thread for this agent. Cascades to messages + artifacts. Returns the count removed.
   * Internal/ops only — bulk delete every thread for this agent.
   *
   * Same Invariant-17 cascade semantics as the single-id delete. No
   * production-route equivalent — wholesale deletion is an ops
   * procedure, not a customer-facing feature.
   * @returns DeleteAllThreadsResponse Successful Response
   * @throws ApiError
   */
  public deleteAllThreadsInternalAgentsShoppingConsultantChannelsDelete(): CancelablePromise<DeleteAllThreadsResponse> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/internal/agents/shopping_consultant/channels',
    });
  }
  /**
   * Ingest a batch of UI Driver events for this onboarding period. Each event becomes one actor='ai_driver_fe' audit row; handler dispatch produces artifact ids (empty in G2; populated in G3/G4).
   * Persist a batch of UI Driver events for the given enrollment
   * period. Each event becomes one `actor='ai_driver_fe'` audit row;
   * handler dispatch produces artifact ids (G2: empty; G3/G4 will fill
   * these in). Transaction-atomic across the batch — Invariant 14.
   *
   * The batch shape (`{onboarding_period_id, events: [...]}`) matches
   * the FE buffer-then-submit demo: queue 1..N events client-side, send
   * once. Use a one-element list for the single-event case.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns UiEventBatchResponse Successful Response
   * @throws ApiError
   */
  public ingestUiEventsInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdUiEventPost(
    onboardingPeriodId: string,
    requestBody: UiEventBatchRequest
  ): CancelablePromise<UiEventBatchResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/ui_event',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal) Stream a chat turn, optionally with an FE-supplied user_context (back-office; no logged-in monolith user required).
   * INTERNAL (back-office) chat stream. Body type carries the optional
   * `user_context` override (honored via `internal_context_builder`), and the
   * turn-inspection frame is emitted for the BO.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public chatStreamSseInternalInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdChatStreamSsePost(
    onboardingPeriodId: string,
    requestBody: InternalChatStreamRequest
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/chat_stream_sse',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) Delete a thread. Cascades to messages + artifacts via DB-level ON DELETE CASCADE — Invariant 17.
   * Internal-only — delete this thread.
   *
   * Per Invariant 17, this cascades atomically to messages + artifacts
   * via the DB's `ON DELETE CASCADE` on their `channel_id` FKs. There is
   * intentionally no "delete messages only" or "delete artifacts only"
   * endpoint — partial deletion below the thread boundary leaves
   * dangling array refs (`messages.artifact_memberships[]`,
   * `artifacts.message_ids[]`, etc.).
   * @param onboardingPeriodId
   * @returns DeleteThreadResponse Successful Response
   * @throws ApiError
   */
  public deleteThreadInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdDelete(
    onboardingPeriodId: string
  ): CancelablePromise<DeleteThreadResponse> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) Snapshot bundle: thread + messages (including wrapped) + artifacts + sub-threads (subagent runs) + prompt info. Read-only inspector for the backoffice.
   * Internal-only inspector — snapshot of thread + all messages +
   * all artifacts + the prompt info the runtime is loading.
   *
   * Read-only; one round-trip, no pagination (dev tool — most sessions
   * have <50 messages). 404 if the thread doesn't exist yet.
   * @param onboardingPeriodId
   * @returns ThreadStateResponse Successful Response
   * @throws ApiError
   */
  public getThreadStateInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdStateGet(
    onboardingPeriodId: string
  ): CancelablePromise<ThreadStateResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/state',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) Static agent-runtime taxonomy: main graph + bound tools + patched subagents (each with its subgraph). Graphs + tools derived live from the compiled graphs; subagent identity/links declared in the agent registry. Powers the BE Agent Runtimes panel.
   * (Internal/dev only) Static agent-runtime taxonomy for the BE Agent
   * Runtimes panel: the active agent's main graph + bound tool palette +
   * patched subagents (each with its own subgraph). Graphs + tools are derived
   * live from the compiled graphs / `TOOLS`; subagent identity + tool links are
   * declared in the agent registry (drift-guarded). No thread scope; pure
   * introspection — no LLM/DB writes.
   * @returns AgentRuntimeManifest Successful Response
   * @throws ApiError
   */
  public getRuntimeManifestInternalAgentsShoppingConsultantRuntimeGet(): CancelablePromise<AgentRuntimeManifest> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/runtime',
    });
  }
  /**
   * (Internal/dev only) DIAGNOSTIC — spawn the throwaway demo subagent to exercise the DF primitive end-to-end. Body carries onboarding_period_id + sub-thread key + task. Persists an isolated sub-thread + a subagent_output artifact; returns the digest.
   * (Internal/dev only) DIAGNOSTIC — spawn the throwaway demo subagent to
   * exercise the DF primitive end-to-end from the BO. Runs through the
   * `SubagentRunner`; its turns persist isolated under `(kind, thread_id)`
   * (invisible to the main thread), the `subagent_output` artifact + digest
   * cross back. Re-fetch `/state` after to see the quarantined sub-thread.
   * Not a production capability.
   * @param onboardingPeriodId
   * @param threadId
   * @param requestBody
   * @returns SpawnDemoSubagentResponse Successful Response
   * @throws ApiError
   */
  public spawnDemoSubagentInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdThreadsThreadIdEchoPost(
    onboardingPeriodId: string,
    threadId: string,
    requestBody: SpawnDemoSubagentRequest
  ): CancelablePromise<SpawnDemoSubagentResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/threads/{thread_id}/echo',
      path: {
        onboarding_period_id: onboardingPeriodId,
        thread_id: threadId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) Resume a sub-thread conversation (P-2) — drive the agent registered for `kind` directly on its (kind, thread_id) sub-thread. Reply persists isolated from the main thread (I-26).
   * (Internal/dev only) Resume a sub-thread conversation (P-2) — drive the
   * agent registered for `kind` directly on its `(kind, thread_id)`
   * sub-thread. The reply persists under that key, isolated from the main
   * thread (I-26). Not a production capability yet.
   * @param onboardingPeriodId
   * @param threadId
   * @param requestBody
   * @returns SubThreadChatResponse Successful Response
   * @throws ApiError
   */
  public chatThreadInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdThreadsThreadIdChatPost(
    onboardingPeriodId: string,
    threadId: string,
    requestBody: SubThreadChatRequest
  ): CancelablePromise<SubThreadChatResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/threads/{thread_id}/chat',
      path: {
        onboarding_period_id: onboardingPeriodId,
        thread_id: threadId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) Composer output — what the LLM would see if a chat turn were issued right now. Stateless reconstruction; does not invoke the LLM. Used by the backoffice Context Composer tab. Query params: `?view=compact|selective` and `?expand=<id>,<id>` (selective only).
   * Internal-only — return the composer's output for this thread
   * as it stands NOW, in LLM shape.
   *
   * Query parameters:
   * * `view`   — accepted for back-compat. The DC memory model has a
   * single CompactView; `'compact'` and `'selective'` both
   * resolve to it. Closed-episode expansion moved to the
   * raw-message inspector (`/sessions/{opi}/state`).
   * * `expand` — accepted but ignored (see above). Retained so existing
   * callers don't 400; dropped in the step-5 panel merge.
   *
   * Stateless reconstruction: re-runs the memory composer on current
   * thread state. Shows the artifact-augmented message list the LLM
   * would receive if a chat turn were issued right now — useful for
   * verifying rendering without extracting the wire payload from Langfuse
   * or the stream itself.
   *
   * Returns the MEMORY blocks as `ContextBlockView`s (type / variant /
   * status / source / layer / lifecycle / role / content + resolved episode
   * members) — the SAME DTO the chat turn-inspection frame emits, so the BE
   * Context Composer panel renders both sources identically.
   *
   * 404 if the thread doesn't exist yet.
   * @param onboardingPeriodId
   * @param view
   * @param expand
   * @returns ComposedPromptResponse Successful Response
   * @throws ApiError
   */
  public getComposedViewInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdComposedViewGet(
    onboardingPeriodId: string,
    view: string = 'compact',
    expand?: string | null
  ): CancelablePromise<ComposedPromptResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/composed_view',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      query: {
        view: view,
        expand: expand,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Deprecated alias) Same as /composed_view?view=compact. Kept temporarily so older FE clients keep working through the rename window.
   * Internal-only — return the composer's output for this thread
   * as it stands NOW, in LLM shape.
   *
   * Query parameters:
   * * `view`   — accepted for back-compat. The DC memory model has a
   * single CompactView; `'compact'` and `'selective'` both
   * resolve to it. Closed-episode expansion moved to the
   * raw-message inspector (`/sessions/{opi}/state`).
   * * `expand` — accepted but ignored (see above). Retained so existing
   * callers don't 400; dropped in the step-5 panel merge.
   *
   * Stateless reconstruction: re-runs the memory composer on current
   * thread state. Shows the artifact-augmented message list the LLM
   * would receive if a chat turn were issued right now — useful for
   * verifying rendering without extracting the wire payload from Langfuse
   * or the stream itself.
   *
   * Returns the MEMORY blocks as `ContextBlockView`s (type / variant /
   * status / source / layer / lifecycle / role / content + resolved episode
   * members) — the SAME DTO the chat turn-inspection frame emits, so the BE
   * Context Composer panel renders both sources identically.
   *
   * 404 if the thread doesn't exist yet.
   * @param onboardingPeriodId
   * @param view
   * @param expand
   * @returns ComposedPromptResponse Successful Response
   * @throws ApiError
   */
  public getComposedViewInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdComposedPromptGet(
    onboardingPeriodId: string,
    view: string = 'compact',
    expand?: string | null
  ): CancelablePromise<ComposedPromptResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/composed_prompt',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      query: {
        view: view,
        expand: expand,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) FE-audience composition: chat thread + state-widget bundle. NO compaction (chat is for humans). Distinct from /composed_view, which is LLM-shape with compaction. Used by the backoffice chat thread + future production chat FE.
   * Internal-only — return the FE-audience composition for this
   * thread: structured cards + dialogue + episode banners (no
   * compaction). Used by the BO chat thread + future production
   * chat surfaces.
   *
   * Distinct from `/composed_view` (LLM-shape compacted blocks). The
   * two endpoints serve different consumers.
   *
   * 404 if the thread doesn't exist.
   * @param onboardingPeriodId
   * @returns ChatViewResponse Successful Response
   * @throws ApiError
   */
  public getComposedChatViewInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdComposedChatViewGet(
    onboardingPeriodId: string
  ): CancelablePromise<ChatViewResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/composed_chat_view',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal/dev only) One subagent sub-thread's isolated reasoning turns (DV transparency). Keyed by (thread_type, subject_key). INTERNAL ROUTER ONLY — production never exposes subagent turns (I-32, possible PHI).
   * Internal-only — return ONE subagent sub-thread's isolated reasoning
   * turns (DV transparency). Keyed by `(thread_type, subject_key)` — e.g.
   * `('compare', 'plan_a,plan_b')` carried on a `comparison_analysis` card's
   * `sub_thread`. Registered on the INTERNAL router ONLY: subagent turns may
   * carry plan/PHI reasoning, so production never exposes them (I-32).
   *
   * 404 if the thread doesn't exist (an absent sub-thread returns an empty
   * thread, not a 404 — the run may simply not have persisted any turns).
   * @param onboardingPeriodId
   * @param threadType
   * @param subjectKey
   * @returns ChatViewResponse Successful Response
   * @throws ApiError
   */
  public getSubThreadChatViewInternalAgentsShoppingConsultantChannelsOnboardingPeriodIdSubThreadThreadTypeSubjectKeyGet(
    onboardingPeriodId: string,
    threadType: string,
    subjectKey: string
  ): CancelablePromise<ChatViewResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/agents/shopping_consultant/channels/{onboarding_period_id}/sub_thread/{thread_type}/{subject_key}',
      path: {
        onboarding_period_id: onboardingPeriodId,
        thread_type: threadType,
        subject_key: subjectKey,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal) One-shot plan highlights for a discovery plan, with an FE-supplied care_preferences slice (back-office; no logged-in user required — and none available, so the slice is required in practice).
   * INTERNAL (back-office) one-shot highlights. Body type carries the optional
   * `care_preferences` override, which the BO must ship: the `/internal/` prefix
   * bypasses auth, so there is no logged-in user and the monolith fallback 401s.
   *
   * No `authorize_impersonation` dependency — both its grant paths read the
   * logged-in principal, which is always absent here, so requesting impersonation
   * on this mount could only ever 403. The BO's own slice is the identity seam.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns DiscoveryPlanHighlightsResponse Successful Response
   * @throws ApiError
   */
  public planHighlightsEndpointInternalInternalAgentsShoppingConsultantPlanHighlightsOnboardingPeriodIdPost(
    onboardingPeriodId: string,
    requestBody: InternalPlanHighlightsRequest
  ): CancelablePromise<DiscoveryPlanHighlightsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/plan_highlights/{onboarding_period_id}',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * (Internal) Ori's comparison of the plans open in Compare, with an FE-supplied care_preferences slice (back-office).
   * INTERNAL (back-office) one-shot comparison; the BO ships the
   * `care_preferences` slice, as on `plan_highlights_endpoint_internal`, and the
   * summary is recorded like the internal chat route writes its turns. That
   * write lands in the employee's real thread, unprompted, and reflects the
   * BO's preference overrides rather than anything the member set.
   * @param onboardingPeriodId
   * @param requestBody
   * @returns ComparisonSummaryResponse Successful Response
   * @throws ApiError
   */
  public comparisonSummaryEndpointInternalInternalAgentsShoppingConsultantComparisonSummaryOnboardingPeriodIdPost(
    onboardingPeriodId: string,
    requestBody: InternalComparisonSummaryRequest
  ): CancelablePromise<ComparisonSummaryResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/internal/agents/shopping_consultant/comparison_summary/{onboarding_period_id}',
      path: {
        onboarding_period_id: onboardingPeriodId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
